import { connect } from 'react-redux'
import { checkWaiChuBack } from './actions'
import Setting from './main'


const mapDispatchToProps = {
    checkWaiChuBack
}
const mapStateToProps = (state) => {
  return {
    ...state.WaiChuBackCheck
  }
}
  

export default connect(mapStateToProps, mapDispatchToProps)(Setting)
